import { Dialog } from "@constellation-academy/epic-ui";
import React from "react";
import { useTranslation } from "@i18n/hooks";
import { DispatchInputSelectionModalProps } from "./dispatch-input-selection-modal.types";
import { SelectMultipleAccountsForm } from "../../../../features/accounts/select-multiple-accounts-form";
import { SelectMultipleRootNodesForm } from "../../../../features/educational-offer/select-multiple-root-nodes-form";
import { SelectNewsletterOptInForm } from "../../../../features/newsletter";
import { SelectMultipleUsersForm } from "../../../../features/users/select-multiple-users-form";

export const DispatchInputSelectionModal = ({
	isInclusion = true,
	onHide,
	onInputSelected,
	inputType,
}: DispatchInputSelectionModalProps) => {
	const { t } = useTranslation("common");

	let formComponent = null;
	let title = "";
	const handleUserSelection = (selectedUsers: string[]) => {
		onInputSelected(selectedUsers);
		onHide();
	};
	const handleAccountSelection = (selectedAccounts: string[]) => {
		onInputSelected(selectedAccounts);
		onHide();
	};
	const handleRootNodeSelection = (selectedRoots: string[]) => {
		onInputSelected(selectedRoots);
		onHide();
	};
	const handleNewsletterOptInSelection = (selectedOptIn: boolean) => {
		onInputSelected(selectedOptIn);
		onHide();
	};

	switch (inputType) {
		case "user":
			title = isInclusion
				? t("messageDispatch.modalIncludeUsers")
				: t("messageDispatch.modalExcludeUsers");
			formComponent = <SelectMultipleUsersForm onUsersSelected={handleUserSelection} />;
			break;

		case "account":
			title = isInclusion
				? t("messageDispatch.modalIncludeAccounts")
				: t("messageDispatch.modalExcludeAccounts");
			formComponent = (
				<SelectMultipleAccountsForm onAccountSelected={handleAccountSelection} />
			);
			break;

		case "rootNode":
			title = isInclusion
				? t("messageDispatch.modalIncludeCourses")
				: t("messageDispatch.modalExcludeCourses");
			formComponent = (
				<SelectMultipleRootNodesForm onRootNodesSelected={handleRootNodeSelection} />
			);
			break;

		case "newsletterOptIn":
			title = t("messageDispatch.modalNewsletter");
			formComponent = (
				<SelectNewsletterOptInForm onOptInSelected={handleNewsletterOptInSelection} />
			);
			break;

		default:
			return null;
	}

	return (
		<Dialog visible={true} title={title} onHide={onHide}>
			{formComponent}
		</Dialog>
	);
};
